/* eslint-disable react/forbid-prop-types */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import classnames from 'classnames';
import Notification from './Notification';

const Notifications = ({ notifications, onRequestHide, enterTimeout, leaveTimeout }) => {
  const handleRequestHide = (notification) => () => {
    if (onRequestHide) {
      onRequestHide(notification);
    }
  };
  const [hasNotifications, setHasNotifications] = useState(notifications.length > 0);

  useEffect(() => {
    setHasNotifications(notifications.length > 0);
  }, [notifications]);


  return (
    <div className={
      classnames('notification-container', {
        'notification-container-empty': !hasNotifications,
      })
    }>
      <TransitionGroup>
        {notifications.map((notification) => {
          const key = notification.id || new Date().getTime();
          return (
            <CSSTransition
              classNames="notification"
              key={key}
              timeout={{ exit: leaveTimeout, enter: enterTimeout }}
            >
              <Notification
                key={key}
                type={notification.type}
                title={notification.title}
                message={notification.message}
                timeOut={notification.timeOut}
                onClick={notification.onClick}
                onRequestHide={handleRequestHide(notification)}
                customClassName={notification.customClassName}
              />
            </CSSTransition>
          );
        })}
      </TransitionGroup>
    </div>
  );
}
Notifications.propTypes = {
  notifications: PropTypes.array,
  onRequestHide: PropTypes.func,
  enterTimeout: PropTypes.number,
  leaveTimeout: PropTypes.number,
};

Notifications.defaultProps = {
  notifications: [],
  onRequestHide: () => { },
  enterTimeout: 400,
  leaveTimeout: 400,
};
export default Notifications;
